import {Action} from "redux";
import { IClientPmCampaignActionCreator } from "../action/client_pm_campaign";
import { GetCustomersByPmCampaignPageRequest } from "../request/customer_request";

interface IClientPmCampaignDispatcher {
    getCustomers(item: GetCustomersByPmCampaignPageRequest): void;
}

class Dispatcher implements IClientPmCampaignDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientPmCampaignActionCreator) {

    }

    public getCustomers = (item: GetCustomersByPmCampaignPageRequest) => {
        this.dispatch(this.actionCreator.requestGetCustomerByClientPmCampaignPageAction(item));
    }

}

const createClientPmCampaignDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientPmCampaignActionCreator): IClientPmCampaignDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientPmCampaignDispatcher, createClientPmCampaignDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_pm_campaign.ts